import { VALIDATOR_PATTERN } from './validators';

const nieLetters = ['X', 'Y', 'Z'];

export const checkNie = (identifier: string) => {
  const value = identifier.toString().toUpperCase();
  let foundNie = false;
  let i;
  for (i = 0; i < nieLetters.length; i++) {
    if (value.startsWith(nieLetters[i])) {
      foundNie = true;
    }
  }

  return foundNie;
};

export const getNieFormatted = (nie: string, initialLetter: string) => {
  let number = 0;
  switch (initialLetter) {
    case 'Y':
      number = 1;
      break;
    case 'Z':
      number = 2;
      break;
    default:
      number = 0;
  }
  return `${number}${nie.substring(1, 8)}${nie.slice(-1).toUpperCase()}`;
};

const validateId = (
  value: string,
  pattern: RegExp,
  getNumber: (v: string) => string,
  validChars: string,
) => {
  if (!value) return false;
  const finalLetter = value.slice(-1).toUpperCase();
  const charIndex = parseInt(getNumber(value), 10) % 23;
  return pattern.test(value) && validChars.charAt(charIndex) === finalLetter;
};

export const validDNI = (dni: string) =>
  validateId(
    dni,
    VALIDATOR_PATTERN.DNI,
    (v) => v.substring(0, 8),
    VALIDATOR_PATTERN.DNI_CHARS,
  );

export const validNIE = (nie: string) => {
  const initialLetter = nie.slice(0, 1).toUpperCase();
  const isNie = initialLetter === 'X' || initialLetter === 'Y' || initialLetter === 'Z';
  if (!isNie) return false;
  return validateId(
    nie,
    VALIDATOR_PATTERN.NIE,
    (v) => getNieFormatted(v, initialLetter).substring(0, 8),
    VALIDATOR_PATTERN.DNI_CHARS,
  );
};

export const formatName = (str: string): string => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Elimina acentos
    .replace(/</g, " ") // Reemplaza todos los '<' por espacio
    .replace(/[^a-zA-ZñÑçÇüÜ\s]/g, " "); // Elimina otros caracteres especiales conservar letras de otros idiomas (como la ñ, ç, ü, etc.)
}
